import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useEventsV2({
  start,
  end,
  familia = "all",
  produto = null,
  tipos = "EVENTO",
  enabled = true,
}) {
  const { getEvents } = useApiV2();
  const { user } = useAuth();
  const branchId = user?.active_branch_id ?? null;

  return useQuery({
    queryKey: [
      "eventsV2",
      user?.user_id ?? null,
      branchId,
      start,
      end,
      tipos,
      familia,
      produto,
    ],
    queryFn: () =>
      getEvents({
        branch_id: branchId,
        start,
        end,
        tipos,
        familia,
        ...(produto ? { produto } : {}),
      }),
    enabled: enabled && !!branchId && !!start && !!end,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
